// @flow
import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MainLayout } from "./MainLayout";
import Cookies from "js-cookie";
import axios from "axios";
import { BASE_URL } from "./Api/Api";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  unstable_HistoryRouter,
  useLocation,
  useNavigate,
} from "react-router-dom";
import DataTableTemplate from "../../Cpanel/Components/DataTableTemplate";
import { fetchData, formatNumber } from "../../Cpanel/Components/Utilities";
import Helmet from "./Helment";
import DatePickerFormat from "./FormOptions/DatePickerFormat";
import { useForm } from "react-hook-form";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import TransferCoinToUserModal from "./TransferCoinToUserModal";
import { logoutStatic } from "../../StateManagement/authSlice";

const MyCoins = () => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState([]);
  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const [userList, setUserList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isCoinTransferModalOpen, setIsCoinTransferModalOpen] = useState(false);
  const [checkLogin, setCheckLogin] = useState(null);
  const dispatch = useDispatch();
  const defaultValues = {};
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({ defaultValues });
  // const {
  //   name,
  //   family,
  //   regdate: userRegDate,
  //   InsPay,
  //   grade,
  // } = useSelector((state) => state.auth);
  const [freeCoin, setFreeCoin] = useState("");
  const [coin, setCoin] = useState({ coin: "", status: "" });
  const location = useLocation();

  const handleBackNavigation = () => {
    if (!location.state) {
      navigate("/");
    } else {
      navigate(location.state);
    }
  };

  let userLevel = "";
  switch (userInfo?.userinfo?.grade) {
    case 0: {
      userLevel = "عادی";
      break;
    }
    case 1: {
      userLevel = "طلایی";
      break;
    }
    case 2: {
      userLevel = "پالادیوم";
      break;
    }
    default: {
      userLevel = "عادی";
    }
  }

  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultDatatableRows,
    filters: {
      ckDate: { value: "", matchMode: "contains" },
      Mob: { value: "", matchMode: "contains" },
      typename: { value: null, matchMode: FilterMatchMode.IN },
      sex: { value: null, matchMode: FilterMatchMode.IN },
      org: { value: null, matchMode: FilterMatchMode.IN },
    },
  });

  const cols = [
    {
      field: "ckDate",
      header: "ردیف",
      body: (data, options) => options.rowIndex + 1,
    },
    {
      field: "ckDate",
      header: "تاریخ",
    },
    { field: "ckTime", header: "زمان" },
    {
      field: "ckIn",
      header: "سکه دریافتی",
      body: (data) => (
        <p style={{ direction: "ltr", textAlign: "center" }}>
          {formatNumber(data?.ckIn)}
        </p>
      ),
    },
    {
      field: "ckOut",
      header: "سکه خرج شده",
      body: (data) => (
        <p style={{ direction: "ltr", textAlign: "center" }}>
          {formatNumber(data?.ckOut)}
        </p>
      ),
    },
    {
      field: "remain",
      header: "باقیمانده",
      body: (data) => (
        <p style={{ direction: "ltr", textAlign: "center" }}>
          {formatNumber(data?.remain)}
        </p>
      ),
    },
    { field: "ckDesc", header: "توضیحات" },
  ];
  const onFilter = (event) => {
    event["first"] = 0;
    setLazyState((cur) => ({ ...cur, ...event }));
    console.log(event, "on filter");
  };
  useEffect(() => {
    fetchInitialData();
    const bodyUserInfo = new FormData();
    bodyUserInfo.append("guid", Cookies.get("guid"));
    fetchData("guid", bodyUserInfo, handleUserInfoResponse);
  }, []);

  const fetchInitialData = () => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    bodyFormData.append("pageNo", lazyState?.page + 1 ?? 1);
    bodyFormData.append("pageSize", lazyState?.rows ?? 20);
    fetchData("mycoin", bodyFormData, handleApiResponse);
  };
  const handleUserInfoResponse = (data) => {
    setUserInfo(data);
  };
  const onPage = (event) => {
    setLazyState((cur) => ({ ...cur, ...event }));
    setDefaultDatatableRows(event.rows);
  };
  let networkTimeout = null;
  useEffect(() => {
    loadLazyData(lazyState);
  }, [lazyState]);
  const loadLazyData = (data) => {
    setLoading(true);
    if (networkTimeout) {
      clearTimeout(networkTimeout);
    }

    //imitate delay of a backend call
    networkTimeout = setTimeout(() => {
      const bodyFormData = new FormData();
      bodyFormData.append("guid", Cookies.get("guid"));
      bodyFormData.append("pageNo", lazyState?.page + 1 ?? 1);
      bodyFormData.append("pageSize", lazyState?.rows ?? 20);
      if (data?.filters?.name?.value) {
        bodyFormData.append("name", data?.filters?.name?.value);
      }
      if (data?.filters?.groupid?.value) {
        bodyFormData.append("groupid", data?.filters?.groupid?.value);
      }
      if (data?.filters?.sex?.value) {
        bodyFormData.append("sex", data?.filters?.sex?.value);
      }
      if (data?.filters?.Mob?.value) {
        bodyFormData.append("mob", data?.filters?.Mob?.value);
      }
      if (data?.filters?.org?.value) {
        bodyFormData.append("org", data?.filters?.org?.value);
      }
      const handleApiResponse = (data) => {
        setTotalRecords(data?.count);
        setUserList(data?.dt);
        setLoading(false);
      };
      fetchData("mycoin", bodyFormData, handleApiResponse);
    }, Math.random() * 1000 + 250);
  };
  const handleApiResponse = (data) => {
    setFreeCoin(data?.freeCoin);
    setUserList(data?.dt);
    setTotalRecords(data?.count);
    setCoin({ coin: data?.freeCoin, status: data?.data?.status });
   
   setCheckLogin(data?.UserId);
  };
  useEffect(() => {
     if (checkLogin === "0") {
       dispatch(logoutStatic());
       navigate("/");
     }
   }, [checkLogin]);
  const handleFilterDate = () => {};
  return (
    <div className="container">
      <TransferCoinToUserModal
        isOpen={isCoinTransferModalOpen}
        closeModal={() => {
          setIsCoinTransferModalOpen(false);
          fetchInitialData();
        }}
        userId={userInfo?.UserId}
        freeCoin={freeCoin}
        body={true}
      />
      <button
        className=" btn btn-outline-secondary fw-bold d-flex align-items-center gap-2  "
        onClick={handleBackNavigation}
      >
        <span>
          {" "}
          <FontAwesomeIcon
            icon={"arrow-right"}
            className="fa-small "
          ></FontAwesomeIcon>{" "}
        </span>
        <span>بازگشت</span>
      </button>
      <div className="card wd-75 wm-100 m-auto container">
        <div className="card-body">
          <h5 className="card-title text-center">
            <span className="text-warning">
              <FontAwesomeIcon icon="coins" className="header-icon fs4" />
            </span>{" "}
            سکه های من
          </h5>
          <p className="text-center text-warning fs-6">
            هر پارسی معادل 1000 ریال می باشد
          </p>
          <div>
            <button
              className="btn btn-sm px-3 text-white  btn-orange"
              onClick={() => setIsCoinTransferModalOpen(true)}
            >
              انتقال پارسی
            </button>
          </div>
          <div className="row d-flex flex-columns flex-wrap justify-content-around align-items-center coins-no mb-0 fw-bold">
            <p className="col-12 col-lg-3">{` سکه های قابل استفاده: ${formatNumber(
              coin?.coin
            )}پارسی`}</p>
            <span className="col-12 col-lg-3">{`سکه های دریافتی بابت عملکرد زیرمجموعه ها  : ${formatNumber(
              coin?.coin
            )}پارسی`}</span>
            <div className=" col-12 col-lg-6 d-flex align-items-center ">
              <div className="row d-flex align-items-center justify-content-between">
                <div className="col-4 col-lg-4">
                  <DatePickerFormat
                    className="w-100 mb-3"
                    name={"from"}
                    label={"از تاریخ:"}
                    control={control}
                    onChange={
                      (date) => console.log(date)
                      // options.filterCallback(
                      //   JSON.stringify({ from: date, to: watch("to") })
                      // )
                    }
                  />
                </div>
                <div className="col-4 col-lg-4">
                  <DatePickerFormat
                    className="w-100 mb-3"
                    name={"to"}
                    label={"تا تاریخ:"}
                    control={control}
                    onChange={
                      (date) => console.log(date)
                      // options.filterCallback(
                      //   JSON.stringify({ from: watch("from"), to: date })
                      // )
                    }
                  />
                </div>
                <div className="col-4 col-lg-4 mt-2">
                  <button
                    className="btn btn-sm btn-primary "
                    onClick={handleFilterDate}
                  >
                    جستجو
                  </button>
                </div>
              </div>
            </div>
          </div>
          <hr className="mt-0" />
          <main>
            <div className="d-flex flex-column justify-content-center align-items-center tips ">
              <p className="txt-color-secondary">
                {`سطح کاربری شما`}
                <strong>{`${userLevel}`}</strong> {`می باشد`}
              </p>
              <p className="txt-color-secondary">
                با خرید بیمه نامه سطح کاربری خود را اتفاء دهید سپس می توانید از
                پارسی های اندوخته استفاده کنید
              </p>
            </div>
          </main>
          <div className="card">
            <DataTableTemplate
              lazyState={lazyState}
              lazy
              className={"table-border"}
              columns={cols}
              list={userList}
              totalRecords={totalRecords}
              setlazyState={setLazyState}
              setDefaultDatatableRows={setDefaultDatatableRows}
              defaultDatatableRows={defaultDatatableRows}
              width="25rem"
              loading={loading}
              filters={lazyState.filters}
              onPage={onPage}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default () => (
  <Helmet title="سکه های من">
    {" "}
    <MainLayout children={<MyCoins />} />
  </Helmet>
);
